export default __webpack_public_path__ + "static/media/hosting-hero.bdd58d8a.jpg";